export default "__VITE_ASSET__BIrPgXSf__"